<script>
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '@/firebase';
import axios from 'axios';
import { statusBadgeClass, formatDate } from '@/components/utils.js';
export default {
	data() {
		return {
			log: null,
			currentPage: 1,
			errorsPerPage: 10,
			translations: {
				LogActionsEnum: {},
				JobLogStatus: {},
			},
		};
	},
	props: {
		tenant: null,
		locale: null,
		id: null,
	},
	async mounted() {
		this.$i18n.locale = this.locale;
		await this.fetchMarketplaces();
		// TODO: remove
		// await this.$store.dispatch('Chat/authenticateWithFirebase');
		const logId = this.id; // Get the ID from the route parameter
		const docRef = doc(db, `tenants/${this.tenant}/logs`, logId);
		const docSnap = await getDoc(docRef);

		this.fetchTranslations();
		if (docSnap.exists()) {
			this.log = { id: docSnap.id, ...docSnap.data() };
			await this.fetchErrors(); // Fetch errors after setting log
		} else {
			console.log('No such document!');
		}
	},
	computed: {
		paginatedErrors() {
			if (!this.log || !Array.isArray(this.log.errors)) return [];
			const start = (this.currentPage - 1) * this.errorsPerPage;
			const end = start + this.errorsPerPage;
			return this.log.errors.slice(start, end);
		},
		totalPages() {
			if (!this.log || !Array.isArray(this.log.errors)) return 0;
			return Math.ceil(this.log.errors.length / this.errorsPerPage);
		},
		pagesOptions() {
			if (this.log?.errors?.length == 0) return [];
			const PAGES_RANGE = 1;
			const result = [];
			const selectedPage = this.currentPage;

			for (let i = Math.max(1, selectedPage - PAGES_RANGE); i < selectedPage; i++) {
				result.push(i);
			}
			result.push(selectedPage);
			for (
				let i = selectedPage + 1;
				i <= Math.min(this.totalPages, selectedPage + PAGES_RANGE);
				i++
			) {
				result.push(i);
			}

			return result;
		},
	},
	methods: {
		statusBadgeClass,
		formatDate,
		async fetchMarketplaces() {
			try {
				const response = await axios.get(
					`${window.location.origin}/api/v1/linked-marketplaces`,
				);
				this.marketplaces = response.data?.result?.linked_marketplaces?.data;
			} catch (error) {
				console.error('Error fetching marketplaces:', error);
			}
		},
		findMarketplaceById(marketplaceId) {
			return (
				this.marketplaces?.find(
					(marketplace) => marketplace?.marketplace_id === marketplaceId,
				) || null
			);
		},
		async fetchTranslations() {
			// Example API call to fetch translations
			const response = await axios.get(
				'/core/list/enum-list?list[]=LogActionsEnum&list[]=JobLogStatus',
			);
			if (response.data && response.data.result && response.data.result.lists) {
				this.translations = response.data.result.lists;
			}
		},
		async fetchErrors() {
			const errorsCollectionRef = collection(db, `tenants/${this.tenant}/logs/${this.id}/rows`);
			const querySnapshot = await getDocs(errorsCollectionRef);
			const errors = querySnapshot.docs.map((doc) => doc.data()); // This creates an array of error objects
			// Directly assign the errors array to this.log.errors
			this.log.errors = errors[0]?.rows || [];
		},
		translateLogName(logName) {
			return this.translations.LogActionsEnum[logName] || logName;
		},
		translateStatus(status) {
			return this.translations.JobLogStatus[status] || status;
		},
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
			}
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
			}
		},
		goToPage(pageNumber) {
			if (pageNumber >= 1 && pageNumber <= this.totalPages) {
				this.currentPage = pageNumber;
			}
		},
	},
};
</script>
<template>
	<div class="card px-3">
		<div class="card-title">
			<h3 class="p-2 pt-3 pb-0">{{ $t('operations') }} ({{ log?.rows_count || 0 }})</h3>
		</div>
		<table class="vue-tables border border-secondary rounded-lg">
			<thead>
				<tr class="bg-secondary">
					<th class="px-5 py-3">{{ $t('name') }}</th>
					<!-- <th class="px-5">{{ $t("stage") }}</th> -->
					<th class="px-5 py-3">{{ $t('operation-message') }}</th>
				</tr>
			</thead>
			<!-- {{ log?.errors }} -->
			<tbody>
				<tr v-if="paginatedErrors.length === 0">
					<td colspan="2" class="text-center">{{ $t('No Data') }}</td>
				</tr>
				<tr
					v-else
					v-for="(operation, index) in paginatedErrors"
					:key="index"
					class="border border-secondary"
				>
					<td class="px-5">{{ operation?.name }}</td>
					<!-- <td class="px-5">{{ error?.stage }}</td> -->
					<td class="px-5">{{ operation?.message }}</td>
				</tr>
			</tbody>
		</table>
		<div class="pagination-controls">
			<button @click="prevPage" :disabled="currentPage <= 1">{{ $t('previous') }}</button>
			<template v-if="pagesOptions.length > 0 && pagesOptions[0] !== 1 && totalPages > 0">
				<button @click="goToPage(1)">
					{{ 1 }}
				</button>
				<span class="px-1 pt-2">...</span>
			</template>
			<span v-for="n in pagesOptions" :key="n">
				<button
					@click="goToPage(n)"
					:disabled="currentPage === n"
					:class="{ active: currentPage === n }"
				>
					{{ n }}
				</button>
			</span>
			<template
				v-if="pagesOptions.length > 0 && pagesOptions[pagesOptions.length - 1] !== totalPages && totalPages > 0"
			>
				<span class="px-1 pt-2">...</span>
                <button @click="goToPage(totalPages)">
					{{ totalPages }}
				</button>
			</template>
			<button @click="nextPage" :disabled="currentPage >= totalPages">{{ $t('next') }}</button>
		</div>
	</div>
</template>
<style scoped lang="scss">
@import '../styles/index.scss';
</style>
